import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useStyletron } from 'baseui'

const AUTO_HIDE_DURATION = 8000

const GamificationNotification = ({ notification, onClose }) => {
  const [css, theme] = useStyletron()
  const [isExiting, setIsExiting] = useState(false)

  useEffect(() => {
    if (!notification) return

    const timer = setTimeout(() => {
      handleClose()
    }, AUTO_HIDE_DURATION)

    return () => clearTimeout(timer)
  }, [notification])

  const handleClose = () => {
    setIsExiting(true)
    setTimeout(() => {
      setIsExiting(false)
      onClose()
    }, 300)
  }

  if (!notification) return null

  const colorMap = {
    success: {
      background: theme.colors.positive100,
      border: theme.colors.positive,
      text: theme.colors.positive,
    },
    warning: {
      background: theme.colors.warning100,
      border: theme.colors.warning,
      text: theme.colors.warning,
    },
    info: {
      background: theme.colors.accent50,
      border: theme.colors.accent,
      text: theme.colors.accent,
    },
  }

  const colors = colorMap[notification.type] || colorMap.info

  return createPortal(
    <div
      className={css({
        position: 'fixed',
        top: '24px',
        right: '24px',
        zIndex: 10000,
        animationName: {
          from: { transform: 'translateX(120%)', opacity: 0 },
          to: { transform: 'translateX(0)', opacity: 1 },
        },
        animationDuration: '400ms',
        animationTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
        animationFillMode: 'forwards',
        ...(isExiting && {
          animationName: {
            from: { transform: 'translateX(0)', opacity: 1 },
            to: { transform: 'translateX(120%)', opacity: 0 },
          },
          animationDuration: '300ms',
        }),
      })}
    >
      <div
        className={css({
          padding: '1rem 1.25rem',
          backgroundColor: colors.background,
          border: `2px solid ${colors.border}`,
          color: colors.text,
          borderRadius: theme.borders.radius400,
          boxShadow: theme.lighting.shadow700,
          maxWidth: '400px',
          minWidth: '280px',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          ...theme.typography.ParagraphSmall,
        })}
      >
        <span className={css({ fontSize: '1.25rem', flexShrink: 0 })}>
          {notification.type === 'success' ? '🎉' : notification.type === 'warning' ? '⚠️' : '📊'}
        </span>
        <span className={css({ flex: 1 })}>{notification.message}</span>
        <button
          onClick={handleClose}
          className={css({
            background: 'none',
            border: 'none',
            color: colors.text,
            cursor: 'pointer',
            padding: '0.25rem',
            fontSize: '1rem',
            lineHeight: 1,
            flexShrink: 0,
            ':hover': { opacity: 0.7 },
          })}
        >
          ✕
        </button>
      </div>
    </div>,
    document.body,
  )
}

export default GamificationNotification
